import { Link } from "react-router-dom";
import { PageHero, Section } from "../components/PageKit";
import { PRINCIPLE, ProcessGrid } from "../components/HomeSections";
import HeroSlider from "../components/HeroSlider";
import { usePageMeta } from "../lib/seo";

const CYCLE = [
  ["Community Entry", "We are invited or identify a community through research, partners or a reported need."],
  ["Research Consent", "Leaders, women's and youth representatives consent to a needs assessment."],
  ["Needs Assessment", "Household surveys, focus groups and observation document the real situation."],
  ["Community Validation", "Findings are presented back and confirmed publicly by the community."],
  ["Project Prioritisation", "Needs are ranked by evidence, urgency, reach and feasibility."],
  ["Project Design", "A costed intervention with beneficiaries, timeline and maintenance plan. A DKF-PRJ number is issued."],
  ["Funding", "Sponsors, donors and partners fund the project transparently against the published budget."],
  ["Procurement", "Competitive, documented procurement with conflict-of-interest declarations."],
  ["Implementation", "Delivered with local labour and community oversight committees."],
  ["Monitoring", "Field reporting, photographs and spending updates published to the project page."],
  ["Completion", "Completion report and independent verification."],
  ["Handover", "Formal handover to the community with roles and responsibilities agreed."],
  ["Maintenance", "Community maintenance committee and agreed contribution arrangements."],
  ["Long-Term Impact", "Follow-up at 3, 6 and 12 months; outcomes and impact recorded separately from outputs."],
  ["Public Reporting", "Impact report published; donors and sponsors notified."],
  ["Learning & Improvement", "Lessons feed the next cycle — repeat with improvement."],
];

export default function OperatingModel() {
  usePageMeta("Community Development Operating Model", "From research consent to implementation, funding, completion, maintenance and long-term impact — how Dutsen Kauna Foundation works.");
  return (
    <div data-testid="operating-model-page">
      <PageHero kicker="How we work" title="Community Development Operating Model" text="From Research Consent to Implementation, Funding, Completion, Maintenance and Long-Term Impact." image="https://images.unsplash.com/photo-1565958923272-e96dbb1e8414?w=1800&q=80">
        <Link to="/report-a-need" className="dk-btn-primary">Report a community need</Link>
        <Link to="/sponsor-a-project" className="dk-btn-outline">Sponsor a project</Link>
      </PageHero>
      <Section kicker="Core operating principle" title="Eight commitments behind every intervention." className="bg-[#f8f4e8]">
        <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="om-principle">
          {PRINCIPLE.map((p, i) => <li key={p} className="p-5 rounded-xl bg-white border border-black/5"><div className="font-mono text-xs text-[#d6aa43]">0{i + 1}</div><div className="font-serif text-lg font-bold text-[#0a0d12] mt-1">{p}</div></li>)}
        </ol>
      </Section>
      <Section kicker="Eight steps" title="From listening to improvement." id="process">
        <ProcessGrid />
      </Section>
      <div data-testid="om-chapters"><HeroSlider /></div>
      <Section kicker="The full cycle" title="Sixteen stages. One accountable system.">
        <ol className="relative border-l-2 border-[#d6aa43]/40 ml-3 space-y-8" data-testid="om-cycle">
          {CYCLE.map(([t, d], i) => (
            <li key={t} className="pl-8 relative">
              <span className="absolute -left-[11px] top-1 w-5 h-5 rounded-full bg-[#155e3f] text-[#d6aa43] text-[10px] font-mono flex items-center justify-center">{i + 1}</span>
              <h3 className="font-serif text-xl font-bold text-[#0a0d12]">{t}</h3>
              <p className="text-sm text-[#0a0d12]/70 mt-1 max-w-2xl">{d}</p>
            </li>
          ))}
        </ol>
      </Section>
    </div>
  );
}
